import { TDdpMedia } from "@/shared/types";
import { ReactNode, VideoHTMLAttributes } from "react";
import { DdpVideo } from "./DdpVideo";

export function FullVideo( props: {
    video: TDdpMedia;
    className?: string;
    children?: ReactNode;
} & VideoHTMLAttributes<HTMLVideoElement>) {
    const { video, className, children,...rest } = props;
    return (
        <DdpVideo className={`full-video-container ${className || ''}`} video={video} autoPlay {...rest} >
            {children}
        </DdpVideo>
    );
}